import "./SellMyCar.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CarDepreciationValueMessaging from "./sections/CarDepreciationValueMessaging";
import VehicleAppraisalForm from "./sections/VehicleAppraisalForm";
import RecentlyBoughtVehicles from "./sections/RecentlyBoughtVehicles";
import Footer from "@/reusable_sections/Footer";
export default function SellMyCarPage() {
  return <div>
      <Header />
      <Hero />
      <CarDepreciationValueMessaging />
      <VehicleAppraisalForm />
      <RecentlyBoughtVehicles />
      <Footer />
    </div>;
}